import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { buildPageViewMetadata, buildSanitizedPagePath } from '@mts/utils';
import { trackVisitorEvent } from '../../services/visitorTracking.js';

export default function PageViewTracker() {
  const location = useLocation();
  const lastLocationKeyRef = useRef(null);
  const previousPathRef = useRef(null);

  useEffect(() => {
    const locationKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastLocationKeyRef.current === locationKey) {
      return;
    }

    const previousPath = previousPathRef.current;
    const metadata = buildPageViewMetadata({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      referrer: document.referrer || '',
      title: document.title || '',
      navigationKind: previousPath ? 'route_change' : 'initial',
      previousPath,
    });

    lastLocationKeyRef.current = locationKey;
    previousPathRef.current = buildSanitizedPagePath({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    });

    trackVisitorEvent({
      eventType: 'page.viewed',
      metadata,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
